<!-- The two buttons at the bottom of an edit dialog (AppDialog.vue's "footer" slot, a row by default): Delete on the left (a bin, with its label from sm up) and Save taking the rest of the row,
     the same in every edit dialog (video, hook, source, saved video, creator, analysed video, format). For a new item
     Delete is hidden, not removed. deleteId: the button's id (the tools and the guided tour use them). It only emits:
     the dialog asks before deleting (confirmDelete, src/stores/notices.ts). -->
<script setup lang="ts">
import { useI18n } from '../../composables/useI18n'

withDefaults(defineProps<{ deleteId: string; canDelete: boolean; deleteLabel?: string; saveLabel?: string }>(), { deleteLabel: '', saveLabel: '' })
const emit = defineEmits<{ delete: []; save: [] }>()
const { t } = useI18n()
</script>

<template>
  <button :id="deleteId" type="button" :title="deleteLabel || t('Delete')" :aria-label="deleteLabel || t('Delete')"
    :class="['bg-darkinput hover:bg-red-950/60 text-brand px-4 py-3 rounded-xl font-bold text-sm transition border border-gray-800 flex items-center justify-center gap-2 flex-shrink-0', { hidden: !canDelete }]" @click="emit('delete')">
    <i class="fas fa-trash"></i><span v-if="deleteLabel" class="hidden sm:inline">{{ deleteLabel }}</span>
  </button>
  <button type="button" class="flex-1 bg-brand hover:bg-brandDark text-white py-3 rounded-xl font-bold text-sm shadow-lg flex items-center justify-center space-x-2 cursor-pointer transition" @click="emit('save')">
    <i class="fas fa-check"></i> <span>{{ saveLabel || t('Save') }}</span>
  </button>
</template>
